import React from 'react';
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import MarathondEventFields from '@jumbo/Dashboards/Tests/MarathonEventFields';

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: <IntlMessages id={'pages.marathonEveventsPage'} />, link: '/tests' },
  { label: <IntlMessages id={'pages.createMarathonEventPage'} />, isActive: true },
];

const CreateMarathonEvent = () => {
  return (
    <PageContainer heading={<IntlMessages id="pages.createMarathonEventPage" />} breadcrumbs={breadcrumbs}>
      <GridContainer>
        <Grid item xs={12}>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <MarathondEventFields />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default CreateMarathonEvent;